
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { useAuthStore } from "./store/auth.store";

// 🔥 CRÍTICO: Inicializar el store ANTES de renderizar la app.
// Esto evita que RequireAuth vea initialized=false en el primer render.
useAuthStore.getState().init();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
